import { render, staticRenderFns } from "./presence.vue?vue&type=template&id=045bc1d7&"
import script from "./presence.vue?vue&type=script&lang=js&"
export * from "./presence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports